import Actions from 'actions';

const initialState = Object.freeze([]);

function getTiers(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_MEMBER_TIERS_REQUEST:
      return initialState;
    case Actions.FETCH_MEMBER_TIERS_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.FETCH_MEMBER_TIERS_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default getTiers;
